var map = {
	"./baidi.png": "cca0",
	"./baidi2.png": "6357",
	"./bgcenter.png": "a9090",
	"./dazhe.png": "3a79",
	"./diamond_level1.png": "e141",
	"./diamond_level2.png": "348f",
	"./diamond_level3.png": "9eb7",
	"./diamond_level4.png": "7878",
	"./dibudi.png": "32fd",
	"./fengexian.png": "1bfd",
	"./giftpackage_level1.png": "eb06",
	"./giftpackage_level2.png": "cc8a",
	"./giftpackage_level3.png": "e963",
	"./gold_level1.png": "c411",
	"./gold_level2.png": "9894",
	"./gold_level3.png": "cb0f",
	"./gold_level4.png": "eb5d",
	"./gou.png": "9792",
	"./icon_diamond.png": "5589",
	"./icon_gold.png": "25fd",
	"./icon_head.png": "007b",
	"./icon_man.png": "5f17",
	"./icon_roomcard.png": "4c9e",
	"./icon_woman.png": "474f",
	"./kapian.png": "5ebe",
	"./lijifukuan.png": "2d34",
	"./querenbaidi1.png": "fe1c",
	"./querenbaidi2.png": "d08e",
	"./roomcard_level1.png": "272b",
	"./roomcard_level2.png": "51da",
	"./roomcard_level3.png": "edf8",
	"./roomcard_level4.png": "9ae8",
	"./weixin.png": "e0fb",
	"./weixuanzhong.png": "6732",
	"./xuanzhong.png": "f237",
	"./zhifubao.png": "3029",
	"./商城.png": "9c39",
	"./确认订单.png": "4c5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "06e0";